import React from "react";
import assetify from "@quintype/framework/assetify";
import PropTypes from "prop-types";
import logo from "../../../../../assets/images/newslaundry_logo.png";
import { Link } from "@quintype/components";
import subscriptionImage from "../../../../../assets/images/nl-images/paywall-pop-up.png";
import "./request-subscription.m.css";
import { SUBSCRIPTION_PAGE_URL } from "../../../../constants";
import { connect } from "react-redux";
import get from "lodash/get";

const RequestSubscriptionBase = props => {
  const requestSubscriptionText = get(props.config, ["publisher", "publisher", "requestSubscriptionText"], "");
  return (
    <div className="request-subsciption-wrapper" styleName="cta">
      <div styleName="first-content">
        <div>
          <img src={assetify(logo)} alt="subscription image"  styleName="logo"/>
          <div styleName="heading">Subscribe to read the full story</div>
        </div>
        <div styleName="get-access">
          <Link href={SUBSCRIPTION_PAGE_URL + `?story-url=/${props.url}`}>
            <button>Get Access</button>
          </Link>
        </div>
        <div styleName="benefits-wrapper">
          <p styleName="question">What’s included in my subscription?</p>
        </div>
        <div styleName="benefits">
          <div styleName="benefits-description">
            Access to all paywall content, including our podcasts like NL Hafta and Let’s Talk About, our video
            interviews, and comics.
          </div>
          <div styleName="benefits-description">
            Subscriber-only benefits like Zoom sessions with the NL team, and city-based private WhatsApp groups.
          </div>
          <div styleName="benefits-description">Free access to all Newslaundry events and community events.</div>
        </div>
      </div>
      <div styleName="second-content">
        <h2 styleName="question">Why should I pay for news?</h2>
        <p styleName="description">{requestSubscriptionText}</p>
        <p styleName="description">Stories cost perseverance, time and resources. </p>
      </div>
      <div styleName="info-image">
        <img src={assetify(subscriptionImage)} alt="subscription image" />
      </div>
    </div>
  );
};

RequestSubscriptionBase.propTypes = {
  config: PropTypes.object,
  url: PropTypes.string
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {})
});

export const RequestSubscription = connect(mapStateToProps)(RequestSubscriptionBase);
